<script lang="ts" setup>
import { useAuthenticationStore } from "@twiage/view/stores/use-authentication-store";
import { useGeneralStore } from "@twiage/view/stores/use-general-store";

import SimpleHeader from "../../../../packages/view/src/components/SimpleHeader.vue";

const authenticationStore = useAuthenticationStore();
const generalStore = useGeneralStore();
</script>

<template>
  <div>
    <SimpleHeader
      :user="authenticationStore.userTrackedPromise.value"
    ></SimpleHeader>

    <div
      :class="{
        'default-layout-slot-container':
          !generalStore.toggleableGlobalOptions.useFluidLayout,
      }"
    >
      <slot />
    </div>
  </div>
</template>

<style scoped>
.default-layout-slot-container {
  margin-inline: auto;
  max-width: 60rem;
}
</style>
